import script from "./NoteCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteCreator.vue?vue&type=script&setup=true&lang=js"

import "./NoteCreator.vue?vue&type=style&index=0&id=e8d4a564&lang=scss&scoped=true"

import exportComponent from "/Users/sam/WebDev/Projects/debtnote/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8d4a564"]])

export default __exports__